import { BrandConfig } from '../../types/config.types';

export const rumidimurConfig: BrandConfig = {
    // ============================================
    // ОСНОВНАЯ ИНФОРМАЦИЯ
    // ============================================
    id: 'rumidimur',
    name: 'Rumidimur',
    description: 'AI Medical Assistant',

    // ============================================
    // API И BACKEND
    // ============================================
    apiUrl: 'https://db.lazydoc.ai',
    defaultPrompt: 'LD-App-Base',

    // ============================================
    // ЛОГОТИПЫ
    // ============================================
    logos: {
        small: 'rumidimur/logos/small-logo.svg', // 32x32px для закрытого сайдбара
        full: 'rumidimur/logos/full-logo.svg', // 160x24px для открытого сайдбара
        auth: 'rumidimur/logos/full-logo.svg', // 200x30px для страницы авторизации
        favicon: 'rumidimur/favicon.ico',
    },

    // ============================================
    // ТЕМА
    // ============================================
    theme: {
        primary: '#DBBC75',
        secondary: '#FFF9ED',
        accent: '#FFF9ED',
        background: '#FFFCF6',
        text: '#222222',
        messageBackground: '#FFF9ED',
        cssVariables: {
            '--rumidimur-primary': '#DBBC75',
            '--rumidimur-secondary': '#FFF9ED',
            '--rumidimur-accent': '#FFF9ED',
        },
    },

    // ============================================
    // PWA МАНИФЕСТ
    // ============================================
    manifest: {
        name: 'Rumidimur - AI Medical Assistant',
        shortName: 'Rumidimur',
        description: 'AI medical assistant for creating medical protocols and documentation',
        display: 'standalone',
        startUrl: '/',
        scope: '/',
        orientation: 'portrait',
        backgroundColor: '#FFFFFF',
        themeColor: '#4F46E5',
        iconsFolder: 'lazydoc',
        updateFavicon: true,
        updateTitle: true,
    },

    // ============================================
    // РЕГИСТРАЦИЯ
    // ============================================
    registration: {
        enabled: true,
    },

    // ============================================
    // ЛОКАЛИЗАЦИЯ
    // ============================================
    i18n: {
        defaultLanguage: 'ru',
        supportedLanguages: ['ru', 'en'],
    },

    // ============================================
    // ДОПОЛНИТЕЛЬНО
    // ============================================
    customSettings: {
        analyticsEnabled: true,
        feedbackEnabled: true,
    },
};